// extracted by mini-css-extract-plugin
export default {"config-nav-button":"ConfigurationNavButton_config-nav-button__VMPmP"};